import * as yup from 'yup';

const EndpointSchema = yup.object().shape({

}).required();

export default EndpointSchema